const VEHICLE_CONFIGURATION_ATTRIBUTES_PREFIX = 'VEHICLE_CONFIGURATION_ATTRIBUTES';
export const VEHICLE_CONFIGURATION_ATTRIBUTES_GET_REQUEST = `${VEHICLE_CONFIGURATION_ATTRIBUTES_PREFIX}_GET_REQUEST`;
export const VEHICLE_CONFIGURATION_ATTRIBUTES_GET_SUCCESS = `${VEHICLE_CONFIGURATION_ATTRIBUTES_PREFIX}_GET_SUCCESS`;
export const VEHICLE_CONFIGURATION_ATTRIBUTES_GET_FAILURE = `${VEHICLE_CONFIGURATION_ATTRIBUTES_PREFIX}_GET_FAILURE`;
export const getVehicleConfigurationAttributesRequestAction = (payload) => ({
    type: VEHICLE_CONFIGURATION_ATTRIBUTES_GET_REQUEST,
    payload
});
export const getVehicleConfigurationAttributesSuccessAction = (payload) => ({
    type: VEHICLE_CONFIGURATION_ATTRIBUTES_GET_SUCCESS,
    payload
});
export const getVehicleConfigurationAttributesFailureAction = (errorMessage) => ({
    type: VEHICLE_CONFIGURATION_ATTRIBUTES_GET_FAILURE,
    payload: errorMessage
});
//# sourceMappingURL=getVehicleConfigurationAttributesActions.js.map